import { Button, Card, Col, Divider, Input, InputNumber, List, Row, Select, Space, Spin, Upload, notification } from "antd";
import Skeleton from "antd/es/skeleton";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeaderAstena from "../../Components/PageHeaderAstena";
import { BCCustomValues } from "../../Interfaces/BCCustomValues";
import { BCServiceItemLine } from "../../Interfaces/BCServiceItemLine";
import { BCServiceItemLog } from "../../Interfaces/BCServiceItemLog";
import { BCServiceLine } from "../../Interfaces/BCServiceLine";
import { Service } from "../../Interfaces/Service";
import { DataService } from "../../Services/DataService";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { BCEditServiceLine } from "../../Interfaces/BCServiceInfoRequest";
import { BCServiceOrder } from "../../Interfaces/BCServiceOrder";
import { BCAddVerbruikRequest } from "../../Interfaces/BCAddVerbruikRequest";
import AddVerbruikModal from "./Components/AddVerbruikModal";
import { BCServiceComment } from "../../Interfaces/BCServiceComment";
import { BCAddCommentRequest } from "../../Interfaces/BCAddCommentRequest";
import AddCommentModal from "./Components/AddCommentModal";
import { SharepointDocument } from "../../Interfaces/SharepointDocument";
import { SharepointService } from "../../Services/SharepointService";
import { useAppSelector } from "../../Redux/hooks";
import { BCDocumentAttachment } from "../../Interfaces/BCDocumentAttachment";
import Dragger from "antd/es/upload/Dragger";
import { RcFile } from "antd/es/upload";
import { GetFileIcon } from "../../Helpers/GetFileIcon";
import { BCServiceHistory } from "../../Interfaces/BCServiceHistory";


type OrderParams = {
    orderId: string;
    lineNo: string;
}

const ServiceItemDetail = () => {

    let navigate = useNavigate();
    let params = useParams<OrderParams>();

    let sharepointSite = useAppSelector(state => state.app.sharepointSite);

    const [serviceItemLine, setServiceItemLine] = useState<Service<BCServiceItemLine>>({ status: "loading" });
    const [serviceLines, setServiceLines] = useState<Service<BCServiceLine[]>>({ status: "loading" });
    //const [logs, setLogs] = useState<Service<BCServiceItemLog[]>>({ status: "loading" });
    const [comments, setComments] = useState<Service<BCServiceComment[]>>({ status: "loading" });
    const [taken, setTaken] = useState<Service<BCCustomValues[]>>({ status: "loading" });
    const [order, setOrder] = useState<Service<BCServiceOrder>>({ status: "loading" });
    const [serviceHistory, setServiceHistory] = useState<Service<BCServiceHistory[]>>({ status: "loading" });

    const [selectedTaak, setSelectedTaak] = useState<string | undefined>();
    const [quantities, setQuantities] = useState<Map<number, number>>(new Map());

    const [isDirty, setIsDirty] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [verbruikLoading, setVerbruikLoading] = useState(false);
    const [commentsLoading, setCommentsLoading] = useState(false);

    const [verbruikOpen, setVerbruikOpen] = useState(false);
    const [commentOpen, setCommentOpen] = useState(false);

    //const [documents, setDocuments] = useState<Service<BCDocumentAttachment[]>>({ status: "loading" });
    const [documents, setDocuments] = useState<Service<SharepointDocument[]>>({ status: "loading" });
    const [isUploading, setIsUploading] = useState(false);
    const [selectedHistory, setSelectedHistory] = useState<BCServiceHistory | null>(null);

    const [isDownloadingHistory, setIsDownloadingHistory] = useState(false);




    React.useEffect(() => {
        if (params.orderId && params.lineNo) {
            DataService.getServiceItemLine(params.orderId, Number(params.lineNo)).then(res => {
                setServiceItemLine(res);
                if (res.status === "loaded") {
                    /*DataService.getLogs(res.payload.serviceItemNo).then(res2 => {
                        setLogs(res2);
                    }).catch(err => {
                        setLogs({ status: "error", error: err })
                    });*/
                    DataService.getServiceHistory(res.payload.serviceItemNo).then(res3 => {
                        setServiceHistory(res3);
                    }).catch(err => {
                        setServiceHistory({ status: "error", error: err })
                    });
                    //fetchAttachments();
                }
            }).catch(err => {
                setServiceItemLine({ status: "error", error: err })
            });
            getServiceLines();
            getServiceComments();
            DataService.getCustomTaken().then(res => {
                setTaken(res);
            }).catch(err => {
                setTaken({ status: "error", error: err })
            });
            DataService.getServiceOrder(params.orderId).then(res => {
                setOrder(res);
            }).catch(err => {
                setOrder({ status: "error", error: err })
            })

        }

    }, []);

    /*function fetchAttachments() {
        DataService.getAttachments(params.orderId!, Number(params.lineNo)).then(res2 => {
            setDocuments(res2);
        }).catch(err => {
            setDocuments({ status: "error", error: err })
        });
    }*/
    React.useEffect(() => {
        fetchAttachments()
    }, [order.status, serviceItemLine.status]);
    function fetchAttachments() {
        if (order.status === "loaded" && serviceItemLine.status === "loaded")
            SharepointService.getDocuments({
                sharepointSite: order.payload.sharepointSite,
                serviceOrderNo: order.payload.no,
                serviceItemNo: serviceItemLine.payload.serviceItemNo,
                serviceItemDescription: serviceItemLine.payload.description
            }).then(res2 => {
                setDocuments(res2);
            }).catch(err => {
                setDocuments({ status: "error", error: err })
            });
    }

    function resetAttachments() {
        if (order.status === "loaded" && serviceItemLine.status === "loaded") {
            setIsUploading(true);
            SharepointService.getDocuments({
                sharepointSite: order.payload.sharepointSite,
                serviceOrderNo: order.payload.no,
                serviceItemNo: serviceItemLine.payload.serviceItemNo,
                serviceItemDescription: serviceItemLine.payload.description
            }).then(res2 => {
                setDocuments(res2);
            }).catch(err => {
                setDocuments({ status: "error", error: err })
            }).finally(() => {
                setIsUploading(false);
                setSelectedHistory(null)
            });
        }
    }

    function getServiceLines() {
        if (params.orderId && params.lineNo) {
            setVerbruikLoading(true);
            DataService.getServiceLines(params.orderId, Number(params.lineNo)).then(res => {
                setServiceLines(res);
            }).catch(err => {
                setServiceLines({ status: "error", error: err })
            }).finally(() => setVerbruikLoading(false));
        }
    }
    function getServiceComments() {
        if (params.orderId && params.lineNo) {
            setCommentsLoading(true);
            DataService.getServiceLineComments(params.orderId, Number(params.lineNo)).then(res => {
                setComments(res);
            }).catch(err => {
                setComments({ status: "error", error: err })
            }).finally(() => setCommentsLoading(false));
        }
    }

    function onSaveInfo() {
        if (params.orderId && params.lineNo) {
            setSaveLoading(true);

            let toSendLines: BCEditServiceLine[] = [];
            quantities.forEach((val, key) => {
                toSendLines.push({
                    lineNo: key,
                    quantity: val
                })
            });

            DataService.saveServiceInfo({
                editLines: toSendLines,
                orderNo: params.orderId,
                serviceItemLineNo: Number(params.lineNo),
                executedTask: selectedTaak ? selectedTaak : ""
            }).then(res => {
                notification.success({
                    message: "Opslaan gelukt."
                });
                setIsDirty(false);

            }).catch(err => {
                notification.error({
                    description: err.error.response.data.Message,
                    message: "Opslaan info mislukt.",
                    duration: 8
                })
            }).finally(() => {
                setSaveLoading(false);
            });
        }
    }

    function onDeleteVerbruik(lineNo: number) {
        if (params.orderId && params.lineNo) {
            setVerbruikLoading(true);
            DataService.deleteVerbruik({
                lineNo: lineNo,
                orderNo: params.orderId,
                serviceItemLineNo: Number(params.lineNo)
            }).then(res => {
                notification.success({
                    message: "Verwijderen verbruik gelukt."
                });
                getServiceLines();
            }).catch(err => {
                notification.error({
                    description: err.error.response.data.Message,
                    message: "Verwijderen verbruik mislukt.",
                    duration: 8
                });
                setVerbruikLoading(false);
            });
        }
    }

    function onAddVerbruik(request: BCAddVerbruikRequest) {
        return new Promise<void>((resolve, reject) => {

            setVerbruikLoading(true);
            DataService.addVerbruik(request).then(res => {
                notification.success({
                    message: "Toevoegen verbruik gelukt."
                });
                getServiceLines();
                setVerbruikOpen(false);
            }).catch(err => {
                notification.error({
                    description: err.error.response.data.Message,
                    message: "Toevoegen verbruik mislukt.",
                    duration: 8
                });
                setVerbruikLoading(false);
                reject();
            }).finally(() => resolve());
        })
    }
    function onAddComment(request: BCAddCommentRequest) {
        return new Promise<void>((resolve, reject) => {

            setCommentsLoading(true);
            DataService.addServiceComment(request).then(res => {
                notification.success({
                    message: "Toevoegen opmerking gelukt."
                });
                getServiceComments();
                setCommentOpen(false);
            }).catch(err => {
                notification.error({
                    description: err.error.response.data.Message,
                    message: "Toevoegen opmerking mislukt.",
                    duration: 8
                });
                setCommentsLoading(false);
                reject();
            }).finally(() => resolve());
        })
    }


    function getBase64(
        file: RcFile,
        callback: (s: string | ArrayBuffer | null) => void
    ) {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(file);
    }

    const uploadDocument = (base: string, fileName: string) => {
        if (order.status === "loaded" && serviceItemLine.status === "loaded") {
            setIsUploading(true);
            SharepointService.uploadFile({
                base64: base,
                fileName: fileName,
                sharepointSite: sharepointSite ? sharepointSite : "",
                serviceItemDescription: serviceItemLine.payload.description,
                serviceItemLineNo: serviceItemLine.payload.lineNo,
                serviceItemNo: serviceItemLine.payload.serviceItemNo,
                serviceOrderNo: order.payload.no
            })
                .then(() => {
                    //setUploadList(undefined);
                    fetchAttachments();
                    notification.success({
                        message: "Bestand werd succesvol toegevoegd."
                    })
                })
                .catch((error) => {
                    notification.error({
                        message: "Bestand toevoegen mislukt."
                    });
                })
                .finally(() => {
                    setIsUploading(false);
                });
        }
    };

    const downloadDocumentSharepoint = (doc: SharepointDocument) => {
        if (order.status === "loaded" && serviceItemLine.status === "loaded") {

            let site = order.payload.sharepointSite;
            if (selectedHistory) {
                site = selectedHistory.sharepointSite;
            }
            setIsUploading(true);
            SharepointService.downloadFile(site, doc.relativeUrl).then(res => {
                //console.log(res);
                if (res.status === "loaded") {
                    var a = document.createElement("a");
                    a.href = `data:application/octet-stream;base64,${res.payload}`;
                    a.setAttribute("download", doc.fileName);
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.parentNode?.removeChild(a); //afterwards we remove the element again
                }
            }).finally(() => setIsUploading(false))
        }
    }

    const downloadDocument = (doc: BCDocumentAttachment) => {
        if (order.status === "loaded" && serviceItemLine.status === "loaded") {
            setIsUploading(true);
            DataService.downloadAttachment({
                documentId: doc.id,
                serviceItemLineNo: serviceItemLine.payload.lineNo,
                serviceOrderNo: order.payload.no,
                fileExtension: doc.fileExtension,
                fileName: doc.fileName
            }).then(res => {
                //console.log(res);
                if (res.status === "loaded") {
                    var a = document.createElement("a");
                    a.href = `data:application/octet-stream;base64,${res.payload}`;
                    a.setAttribute("download", doc.fileName + "." + doc.fileExtension);
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.parentNode?.removeChild(a); //afterwards we remove the element again
                }
            }).finally(() => setIsUploading(false))
        }
    }

    const showHistoryDocuments = (log: BCServiceHistory) => {
        if (!log.sharepointSite) {
            notification.error({
                message: "Geen Sharepoint site gevonden."
            });
            return;
        }
        setIsDownloadingHistory(true);
        setIsUploading(true);
        SharepointService.getDocuments({
            sharepointSite: log.sharepointSite,
            serviceOrderNo: log.serviceOrderNo,
            serviceItemNo: "",
            serviceItemDescription: ""
        }).then(res2 => {
            setDocuments(res2);
            setSelectedHistory(log);
        }).catch(err => {
            //setDocuments({ status: "error", error: err })
            notification.error({
                message: "Bestanden niet gevonden voor service order."
            });
        }).finally(() => {
            setIsDownloadingHistory(false);
            setIsUploading(false);

        });
    }

    const downloadHistory = (orderNo: string) => {
        setIsDownloadingHistory(true);
        DataService.downloadServiceOrderPdf(orderNo).then(res => {
            //console.log(res);
            if (res.status === "loaded") {
                var a = document.createElement("a");
                a.href = `data:application/octet-stream;base64,${res.payload}`;
                a.setAttribute("download", orderNo + ".pdf");
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.parentNode?.removeChild(a); //afterwards we remove the element again
            }
        }).finally(() => setIsDownloadingHistory(false))
    }


    return (
        <div>
            {verbruikOpen && params.orderId && params.lineNo && (
                <AddVerbruikModal isLoading={verbruikLoading} isOpen={verbruikOpen} onCancel={() => setVerbruikOpen(false)}
                    onOk={onAddVerbruik} orderNo={params.orderId} serviceItemLineNo={params.lineNo}
                />
            )}
            {commentOpen && params.orderId && params.lineNo && (
                <AddCommentModal isLoading={commentsLoading} isOpen={commentOpen} onCancel={() => setCommentOpen(false)}
                    onOk={onAddComment} orderNo={params.orderId} serviceItemLineNo={params.lineNo}
                />
            )}
            <Card style={{ marginBottom: 4 }} bodyStyle={{ padding: 16, margin: 0 }}>
                <PageHeaderAstena
                    //style={{ padding: "16px 16px 0px 16px" }}
                    title={
                        serviceItemLine.status === "loaded" ? (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "#959595" }}>{serviceItemLine.payload.serviceItemNo}</span>
                                <Title style={{ margin: 0, color: "#69ACFD", verticalAlign: "middle" }} level={3}>{serviceItemLine.payload.description}</Title>
                            </div>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Skeleton.Input active style={{ marginBottom: 4 }} />
                                <Skeleton.Input active style={{ minWidth: 350 }} />
                            </div>
                        )
                    }
                    extra={serviceItemLine.status === "loaded" ? [
                        <Button disabled={!isDirty} type="primary" onClick={onSaveInfo} loading={saveLoading}>Opslaan</Button>
                    ] : []}
                    onBack={() => navigate(-1)}
                />
            </Card>
            <Row gutter={[4, 4]}>
                <Col xl={8} lg={8} md={12} sm={24}>
                    {serviceItemLine.status === "loaded" && (
                        <Card style={{ marginBottom: 4 }} bodyStyle={{ padding: 16, margin: 0 }}>
                            <PageHeaderAstena
                                style={{ padding: 0, margin: 0, marginBottom: 16 }}
                                title={
                                    <div style={{ color: "#69ACFD", fontSize: 16, marginBottom: 8 }}>{"Algemene info"}</div>
                                }

                            />
                            <div style={{ marginLeft: 8 }}>
                                <span style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}>
                                    <span style={{ color: "#959595", flex: 0.4, fontSize: 12 }}>Serienummer</span>
                                    <span style={{ fontWeight: "bold", flex: 0.6 }}>{serviceItemLine.payload.serialNo}</span>
                                </span>
                                <span style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}>
                                    <span style={{ color: "#959595", flex: 0.4, fontSize: 12 }}>Service artikel groep</span>
                                    <span style={{ fontWeight: "bold", flex: 0.6 }}>{serviceItemLine.payload.serviceItemGroupCode}</span>
                                </span>
                                <span style={{ display: "flex", flexDirection: "row" }}>
                                    <span style={{ color: "#959595", flex: 0.4, fontSize: 12 }}>Uitgevoerde taak</span>
                                    {order.status === "loaded" && (
                                        <Select
                                            style={{ flex: 0.6 }}
                                            showSearch
                                            filterOption={(inputValue, option) =>
                                                option!.label.toLowerCase().includes(inputValue.toLowerCase())
                                            }
                                            allowClear
                                            showArrow
                                            placeholder="Selecteer taak"
                                            options={
                                                (taken.status === "loaded") ?
                                                    taken.payload.map(x => { return { value: x.value, label: `${x.value}` } })
                                                    : []
                                            }
                                            onChange={(value: string) => {
                                                setSelectedTaak(value);
                                                setIsDirty(true);
                                            }}
                                            defaultValue={order.payload.uitgevoerdeTaak}
                                        />
                                    )}
                                    {order.status === "loading" && (
                                        <Skeleton.Input active style={{ flex: 0.6 }} />
                                    )}
                                </span>
                            </div>
                        </Card>
                    )}
                    {serviceItemLine.status === "loading" && (
                        <Card style={{ marginBottom: 4 }} bodyStyle={{ padding: 16, margin: 0 }}>
                            <Skeleton.Input active />
                            <div style={{ marginTop: 16 }}>
                                <Skeleton.Input block active style={{ height: 100 }} />
                            </div>
                        </Card>
                    )}

                    <Card bodyStyle={{ padding: 16, margin: 0 }}>
                        <PageHeaderAstena
                            style={{ padding: 0, margin: 0, marginBottom: 16 }}
                            title={
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Interne opmerkingen/te bestellen materiaal"}</span>
                            }
                            extra={[
                                <Button
                                    key={1} type="text" style={{ color: "#EF8421", fontWeight: "600" }}
                                    onClick={() => { setCommentOpen(true) }}>{"+ Opmerking toevoegen"}
                                </Button>
                            ]}
                        />
                        <div style={{ marginLeft: 8 }}>
                            {comments.status === "loaded" && (
                                <List
                                    pagination={{
                                        pageSize: 8
                                    }}
                                    locale={{ emptyText: "Geen opmerkingen" }}
                                    dataSource={comments.payload}
                                    loading={commentsLoading}
                                    renderItem={(line) => (
                                        <div>
                                            <div style={{ fontWeight: "bold" }}>{dayjs(line.date).format("DD/MM/YYYY")}</div>
                                            <div style={{ color: "#959595", paddingLeft: 8 }}>{line.comment}</div>
                                            <Divider />
                                        </div>
                                    )}
                                />
                            )}
                            {comments.status === "loading" && (
                                <List
                                    dataSource={Array.from(Array(3).keys())}
                                    renderItem={(log) => (
                                        <div>
                                            <Skeleton.Input block active style={{ height: 75 }} />
                                            <Divider />
                                        </div>
                                    )}
                                />
                            )}
                        </div>
                    </Card>
                </Col>
                <Col xl={8} lg={8} md={12} sm={24}>
                    <Card bodyStyle={{ padding: 16, margin: 0 }}>
                        <PageHeaderAstena
                            style={{ padding: 0, margin: 0, marginBottom: 16 }}
                            title={
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Verbruik"}</span>
                            }
                            extra={[
                                <Button
                                    key={1} type="text" style={{ color: "#EF8421", fontWeight: "600" }}
                                    onClick={() => { setVerbruikOpen(true) }}>{"+ Verbruik toevoegen"}
                                </Button>
                            ]}
                        />
                        <div style={{ marginLeft: 8 }}>
                            {serviceLines.status === "loaded" && (
                                <List
                                    pagination={{
                                        pageSize: 8
                                    }}
                                    loading={verbruikLoading}
                                    locale={{ emptyText: "Geen verbruik" }}
                                    dataSource={serviceLines.payload}
                                    renderItem={(line) => (
                                        <div>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 10 }}>
                                                <span style={{ fontWeight: "bold" }}>{line.description}</span>
                                                <CloseOutlined style={{ color: "red" }} onClick={() => onDeleteVerbruik(line.lineNo)} />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "end" }}>
                                                <InputNumber defaultValue={line.quantity} min={0} style={{ marginRight: 8 }}
                                                    onChange={(value) => {
                                                        if (value) {
                                                            let help = new Map(quantities);
                                                            help.set(line.lineNo, value);
                                                            setQuantities(help);
                                                            setIsDirty(true);
                                                        }

                                                    }}
                                                />
                                                <span>{line.unitOfMeasure}</span>
                                            </div>
                                            <Divider />
                                        </div>
                                    )}
                                />
                            )}
                            {serviceLines.status === "loading" && (
                                <List
                                    dataSource={Array.from(Array(3).keys())}
                                    renderItem={(log) => (
                                        <div>
                                            <Skeleton.Input block active style={{ height: 75 }} />
                                            <Divider />
                                        </div>
                                    )}
                                />
                            )}

                        </div>
                    </Card>
                </Col>
                <Col xl={8} lg={8} md={12} sm={24}>
                    <Card style={{ marginBottom: 4 }} bodyStyle={{ padding: 16, margin: 0 }}>
                        <PageHeaderAstena
                            style={{ padding: 0, margin: 0, marginBottom: 16 }}
                            title={
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Bijlages"}</span>
                            }
                            extra={
                                selectedHistory ?
                                    [
                                        <Button onClick={() => resetAttachments()} icon={<CloseOutlined />} >{selectedHistory.serviceOrderNo}</Button>
                                    ]
                                    :
                                    [
                                        <Upload
                                            key="1"
                                            beforeUpload={(file: RcFile) => {
                                                getBase64(file, (imageUrl) => {
                                                    if (typeof imageUrl == "string") {
                                                        //console.log(imageUrl);
                                                        uploadDocument(imageUrl, file.name);
                                                    }
                                                });
                                                return false;
                                            }}
                                            disabled={isUploading || documents.status === "loading"}
                                            showUploadList={false}
                                        >
                                            <Button
                                                key={1} type="text" style={{ color: "#EF8421", fontWeight: "600" }}
                                                onClick={(e) => e.preventDefault()}>{"+ Bijlage toevoegen"}
                                            </Button>
                                        </Upload>
                                    ]
                            }
                        />
                        {documents.status === "loaded" && (
                            <Spin spinning={isUploading}>
                                <Dragger className="astena-drag" openFileDialogOnClick={false} beforeUpload={(file: RcFile) => {
                                    getBase64(file, (imageUrl) => {
                                        if (typeof imageUrl == "string") {
                                            uploadDocument(imageUrl, file.name);
                                        }
                                    });
                                    return false;
                                }}
                                    disabled={isUploading}
                                    showUploadList={false}>
                                    <List
                                        locale={
                                            {
                                                emptyText: "Geen bijlages."
                                            }
                                        }
                                        size="small"
                                        dataSource={documents.payload}
                                        renderItem={(item) => (
                                            <List.Item
                                                style={{ borderWidth: 0, cursor: "pointer" }}
                                                className="astena-file-item"
                                            >
                                                <span
                                                    onClick={() => downloadDocumentSharepoint(item)}
                                                >
                                                    <Space>
                                                        {GetFileIcon(item.fileName)}
                                                        <span>
                                                            {item.fileName}
                                                        </span>
                                                    </Space>

                                                </span>
                                            </List.Item>
                                        )}
                                    />
                                </Dragger>
                            </Spin>
                        )}

                        {documents.status === "loading" && (
                            <List
                                dataSource={Array.from(Array(3).keys())}
                                renderItem={(log) => (
                                    <div>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: 4 }}>
                                            <Skeleton.Avatar shape="square" active size={"large"} />
                                            <div style={{ paddingLeft: 16 }}>
                                                <Skeleton.Input active />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            />
                        )}

                    </Card>
                    <Card bodyStyle={{ padding: 16, margin: 0 }}>
                        <PageHeaderAstena
                            style={{ padding: 0, margin: 0, marginBottom: 16 }}
                            title={
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Historiek"}</span>
                            }

                        />
                        <div style={{ marginLeft: 8 }}>
                            {serviceHistory.status === "loaded" && (
                                <Spin spinning={isDownloadingHistory}>
                                    <List
                                        pagination={{
                                            pageSize: 8
                                        }}
                                        locale={{ emptyText: "Geen historiek" }}
                                        dataSource={serviceHistory.payload/*.sort((a, b) => b.postingDate.localeCompare(a.postingDate))*/}
                                        renderItem={(log) => (
                                            <Card hoverable style={{ marginBottom: 4 }} bodyStyle={{ padding: 12 }}
                                                onClick={() =>
                                                    showHistoryDocuments(log)
                                                    //downloadHistory(log.documentNo)
                                                }
                                            >
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    {/* <div style={{
                                                        display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
                                                        backgroundColor: "#959595", color: "white", padding: "8px 16px"
                                                    }}>
                                                        <span style={{ fontWeight: "bold" }}>{dayjs(log.postingDate).format("DD/MM")}</span>
                                                        <span style={{ fontSize: 12 }}>{dayjs(log.postingDate).format("YYYY")}</span>
                                                    </div> */}
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", paddingLeft: 16 }}>
                                                        <span style={{ color: "#959595" }}>{log.serviceOrderNo}</span>
                                                        <span style={{ fontWeight: "bold" }}>{log.documentDescription}</span>
                                                    </div>
                                                </div>
                                            </Card>
                                        )}
                                    />
                                </Spin>
                            )}
                            {serviceHistory.status === "loading" && (
                                <List
                                    dataSource={Array.from(Array(3).keys())}
                                    renderItem={(log) => (
                                        <div>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                <Skeleton.Avatar shape="square" active size={"large"} />
                                                <div style={{ paddingLeft: 16 }}>
                                                    <Skeleton.Input active />
                                                </div>
                                            </div>
                                            <Divider />
                                        </div>
                                    )}
                                />
                            )}
                        </div>
                    </Card>
                </Col>
            </Row>

        </div >

    );
};

export default ServiceItemDetail;